import i18n from '@risksmart-app/i18n/src/i18n';

import type { FormConfig } from '../types';

export const getAssetFormConfig = () => {
  return {
    Title: {
      fieldId: 'Title',
      formLabel: i18n.t(`fields.Title`),
      columnHeader: i18n.t(`assets.columns.title`),
      allowAsConditionSource: true,
    },
    Description: {
      fieldId: 'Description',
      formLabel: i18n.t(`fields.Description`),
      columnHeader: i18n.t(`assets.columns.description`),
      allowTargetConditions: true,
      displayType: { displayType: 'textarea' },
    },
    Owners: {
      fieldId: 'Owners',
      formLabel: i18n.t(`fields.Owner`),
      columnHeader: i18n.t(`columns.owners`),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
    },
    Contributors: {
      fieldId: 'Contributors',
      formLabel: i18n.t(`fields.Contributor`),
      columnHeader: i18n.t(`columns.contributors`),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    Status: {
      fieldId: 'Status',
      formLabel: i18n.t(`fields.Status`),
      columnHeader: i18n.t(`assets.columns.status`),
      allowAsConditionSource: true,
      displayType: { displayType: 'rating', ratingKey: 'asset_status' },
    },
    AssetType: {
      fieldId: 'AssetType',
      formLabel: i18n.t(`assets.fields.AssetType`),
      columnHeader: i18n.t(`assets.columns.assetType`),
      allowAsConditionSource: true,
    },
    SerialNumber: {
      fieldId: 'SerialNumber',
      formLabel: i18n.t(`assets.fields.SerialNumber`),
      columnHeader: i18n.t(`assets.columns.serialNumber`),
      allowAsConditionSource: true,
    },
    PurchaseDate: {
      fieldId: 'PurchaseDate',
      formLabel: i18n.t(`assets.fields.PurchaseDate`),
      columnHeader: i18n.t(`assets.columns.purchaseDate`),
      displayType: { displayType: 'date' },
      allowAsConditionSource: true,
    },
    Location: {
      fieldId: 'Location',
      formLabel: i18n.t(`assets.fields.Location`),
      columnHeader: i18n.t(`assets.columns.location`),
      allowAsConditionSource: true,
    },
    Cost: {
      fieldId: 'Cost',
      formLabel: i18n.t(`assets.fields.Cost`),
      columnHeader: i18n.t(`assets.columns.cost`),
      allowAsConditionSource: true,
    },
    DepreciationMethod: {
      fieldId: 'DepreciationMethod',
      formLabel: i18n.t(`assets.fields.DepreciationMethod`),
      columnHeader: i18n.t(`assets.columns.depreciationMethod`),
      allowAsConditionSource: true,
    },
    Assignee: {
      fieldId: 'Assignee',
      formLabel: i18n.t(`assets.fields.Assignee`),
      columnHeader: i18n.t(`assets.columns.assignee`),
      displayType: {
        displayType: 'users',
        multiple: false,
      },
      allowAsConditionSource: true,
    },
    files: {
      fieldId: 'files',
      formLabel: i18n.t(`fields.newFiles`),
      allowTargetConditions: true,
    },
    tags: {
      fieldId: 'tags',
      formLabel: i18n.t(`fields.Tags`),
      columnHeader: i18n.t(`columns.tags`),
      displayType: {
        displayType: 'tags',
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    departments: {
      fieldId: 'departments',
      formLabel: i18n.t(`fields.Departments`),
      columnHeader: i18n.t(`columns.departments`),
      displayType: {
        displayType: 'departments',
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
  } as const satisfies FormConfig;
};
